import type { IconAsset } from '../Icon.types';

const code = (
  <g>
    <path
      d='M13.3333 8.38232V14.2157H1.66667V8.38232H0V14.2157C0 15.1323 0.75 15.8823 1.66667 15.8823H13.3333C14.25 15.8823 15 15.1323 15 14.2157V8.38232H13.3333ZM8.33333 4.07399L10.4917 6.22399L11.6667 5.04899L7.5 0.882324L3.33333 5.04899L4.50833 6.22399L6.66667 4.07399V12.1323H8.33333V4.07399Z'
      fill='black'
    />
  </g>
);

export const upload: IconAsset = {
  bold: {
    l: {
      code,
    },
    m: {
      code,
    },
    s: {
      code,
    },
  },
  regular: {
    l: {
      code,
    },
    m: {
      code,
    },
    s: {
      code,
    },
  },
};
